import React, { FC, useState } from 'react'
import * as ModalStyles from '../../../../../../ModalWindow/modal.styles'
import * as LocalStyles from '../../../styles'
import TabTile from '../../../../../../../../data/components/TabTile'
import { QuestionTypeOption, TrainedQuestion } from '../../types'
import { DatasetQuestion } from '../../trained_questions/dataset-question'

interface DatasetQuestionSectionWithRelevantQuestionProps {
  question: string
  answer: string
  onCreateNewQuestion: (question: string, answer: string, questionType: string) => void
  onUpdate: (id: string, questionBeforeUpdate: string, questionForUpdate: string, answer: string, questionType: string) => void
  mostRelevantQuestion?: TrainedQuestion
  onTextWasChanged?: (active: boolean) => void
  initQuestionType: string
}

export const DatasetQuestionSectionWithRelevantQuestion: FC<DatasetQuestionSectionWithRelevantQuestionProps> = ({
  question,
  answer,
  onCreateNewQuestion,
  onUpdate,
  mostRelevantQuestion,
  onTextWasChanged,
  initQuestionType,
}) => {
  const [expanded, setExpanded] = useState<boolean>(false)
  const handleToggleExpand = () => {
    setExpanded(!expanded)
  }

  return (
    <>
      <ModalStyles.ModalContainerSection style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <ModalStyles.ModalContainerSectionItem>
          <ModalStyles.SubHeader>{'Generated Task'}</ModalStyles.SubHeader>
          <LocalStyles.AnswerInput disabled={true} value={question} />
        </ModalStyles.ModalContainerSectionItem>

        <ModalStyles.ModalContainerSectionItem style={{ marginTop: 16 }}>
          <ModalStyles.SubHeader>{'Generated Query'}</ModalStyles.SubHeader>
          <LocalStyles.AnswerInput
            value={answer}
            disabled={true}
            style={{
              fontFamily: 'monospace',
              whiteSpace: 'pre',
              height: '250px',
            }}
          />
        </ModalStyles.ModalContainerSectionItem>
      </ModalStyles.ModalContainerSection>
      <TabTile
        tab={{
          name: <span>{'Closest Question'}</span>,
        }}
        expanded={expanded}
        onChange={handleToggleExpand}>
        <DatasetQuestion
          question={mostRelevantQuestion.question}
          answer={mostRelevantQuestion.answer}
          createQuestionCallback={onCreateNewQuestion}
          updateQuestionCallback={onUpdate}
          questionType={'relevant'}
          questionId={mostRelevantQuestion.trainingQuestionId}
          onQuestionWasChanged={onTextWasChanged}
          initQuestionType={initQuestionType}
        />
      </TabTile>
    </>
  )
}
